import { View } from '../../compiler'
import { typoStyles } from '../../constants'
import { getColors } from '../../utils/matching-profile'
import MarkdownText from '../MarkdownText'

const AtAGlance = ({
  title,
  description,
  score,
  score_key,
  score_visible = true
}) => {
  const { dark, medium, light } = getColors({ score, score_key })

  return (
    <View
      style={{
        padding: '10px 24px',
        flexDirection: 'row',
        alignItems: 'center'
      }}
    >
      <View
        style={{
          width: 40,
          height: 40,
          position: 'relative',
          flexDirection: 'column',
          justifyContent: 'flex-end',
          alignItems: 'center'
        }}
      >
        {score_visible && (
          <MarkdownText
            style={[typoStyles.H1Black, { marginBottom: 4, color: dark }]}
          >
            {Math.round(score)}
          </MarkdownText>
        )}
        <View
          style={{
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
            height: 4,
            borderRadius: 2,
            backgroundColor: light
          }}
        >
          <View
            style={{
              position: 'absolute',
              left: 0,
              top: 0,
              width: `${score}%`,
              height: 4,
              borderRadius: 2,
              backgroundColor: medium
            }}
          />
        </View>
      </View>
      <View
        style={{
          marginLeft: 24,
          flexDirection: 'column',
          justifyContent: 'flex-end'
        }}
      >
        <MarkdownText
          style={[typoStyles.H2Black, { lineHeight: 1.2, marginBottom: 4 }]}
        >
          {title}
        </MarkdownText>
        <MarkdownText style={[typoStyles.T1Black, { lineHeight: 1.2 }]}>
          {description}
        </MarkdownText>
      </View>
    </View>
  )
}

export default AtAGlance
